import { Component, OnInit } from '@angular/core';
import { FormGroup, Validators, FormControl } from '@angular/forms';
import { Router } from '@angular/router';
import { MainService } from '../../provider/main.service';
import { ApiUrls } from '../../config/api-urls/api-urls';

@Component({
  standalone: false,
  selector: 'app-login',
  templateUrl: './login.component.html'
})
export class LoginComponent implements OnInit {

  loginForm: FormGroup | any;
  permission: any;

  constructor(private router: Router, public mainService: MainService) { }

  ngOnInit() {
    this.loginFormValidation();
    var rememberMe = JSON.parse(localStorage.getItem('rememberMe') || '{}') || '';
    if (rememberMe != '') {
      this.loginForm.patchValue({
        email: window.atob(rememberMe.email),
        password: window.atob(rememberMe.password),
        rememberMe: window.atob(rememberMe.rememberMe)
      })
    }
    localStorage.clear();

  }

  //-------  login form validation -------- //
  loginFormValidation() {
    this.loginForm = new FormGroup({
      email: new FormControl('', [Validators.required, Validators.pattern(/^([a-zA-Z0-9_\-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([a-zA-Z0-9\-]+\.)+))([a-zA-Z]{2,10}|[0-9]{1,3})(\]?)$/i)]),
      password: new FormControl('', Validators.required),
      rememberMe: new FormControl(false)
    });
  }

  // ---------  login form submit ------------- //
  login() {
    let data = {
      'email': this.loginForm.value.email,
      'password': this.loginForm.value.password
    }
    this.mainService.showSpinner()
    this.mainService.postApi(ApiUrls.login, data, 0).subscribe((res: any) => {
      if (res.responseCode == 200) {
        this.mainService.hideSpinner();
        this.permission = res.result.permissions[0]
        this.mainService.successToast(res.responseMessage)
        localStorage.setItem('responseCode', res.responseCode);
        localStorage.setItem('token', res.result.token);
        localStorage.setItem('adminId', res.result._id);
        localStorage.setItem('userType', window.btoa(res.result.userType));
        this.mainService.loginStatus.next(true);
        this.getProfile();
        if (this.loginForm.value.rememberMe) {
          let remData = {
            "email": window.btoa(this.loginForm.value.email),
            "password": window.btoa(this.loginForm.value.password),
            "rememberMe": window.btoa(this.loginForm.value.rememberMe)
          };
          localStorage.setItem('rememberMe', JSON.stringify(remData));
        }
        else {
          localStorage.removeItem("rememberMe");
        }
        // this.router.navigate(['dashboard'])

        if (res.result.token) {
          if (res.result.userType === 'ADMIN') {
            this.router.navigate(['dashboard'])
          }
          if (res.result.userType === 'SUBADMIN') {
            if (this.permission.dashboard === true) {
              this.router.navigate(['dashboard'])
            }
            else if (this.permission.subadminManagement === true) {
              this.router.navigate(['subadmin-mgt'])
            }
            else if (this.permission.patientManagement === true) {
              this.router.navigate(['patient-mgt'])
            }
            else if (this.permission.therapistManagement === true) {
              this.router.navigate(['therapist'])
            }
            else if (this.permission.programTypeManagement === true) {
              this.router.navigate(['program-type-mgt'])
            }
            else if (this.permission.programManagement === true) {
              this.router.navigate(['program-mgt'])
            }
            else if (this.permission.transactionManagement === true) {
              this.router.navigate(['transaction-mgt'])
            }
            else if (this.permission.assesmentManagement === true) {
              this.router.navigate(['assessment'])
            }
            else if (this.permission.contentManagement === true) {
              this.router.navigate(['static-content'])
            }
            else if (this.permission.faqManagement === true) {
              this.router.navigate(['faq-mgt'])
            }
            else if (this.permission.journalManagement === true) {
              this.router.navigate(['journal-mgt'])
            }
            else if (this.permission.notificationManagement === true) {
              this.router.navigate(['notification'])
            }
            else if (this.permission.libraryManagement === true) {
              this.router.navigate(['library-mgt'])
            }
            else if (this.permission.reviewManagement === true) {
              this.router.navigate(['review-mgt'])
            }
            else if (this.permission.queryManagement === true) {
              this.router.navigate(['query-mgt'])
            }
            else if (this.permission.chatManagement === true) {
              this.router.navigate(['chat'])
            }

          }

        }

      } else {

        this.mainService.hideSpinner();
        this.mainService.errorToast(res.responseMessage)
      }
    })

  }

  //  get profile
  getProfile() {
    this.mainService.showSpinner()
    this.mainService.getApi(ApiUrls.profile, 1).subscribe((res: any) => {
      if (res.responseCode == 200) {
        this.mainService.loginData.next(res.result);
        this.mainService.isToken.next(res.responseCode);
        let per = res.result.permissions[0];
        this.mainService.permission.next(per);
        this.mainService.hideSpinner();
      } else {
        this.mainService.hideSpinner();
      }
    })
  }

}
